import ActivityLogs from '../components/logging_activities/ActivityLogs';

function ActivityLogging() {
  return (
    <div>
      {/* Other components */}
      <ActivityLogs />
    </div>
  );
}
export default ActivityLogging;